import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom-v5-compat";
import {
  setSupportProductInfo,
  TravelCategory,
} from "@b2bportal/core-self-serve";
import { TRIPS_PATH } from "@overrides/utilities";
import { homesPostBookingApi } from "../../store";

export const useHomesReservationPage = () => {
  const { reservationId } = useParams<{ reservationId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (reservationId == null || reservationId === "") {
    throw new Error("Missing or empty reservationId parameter");
  }

  const navigateToTrips = useCallback(() => {
    navigate(TRIPS_PATH, { replace: true });
  }, [navigate]);

  const {
    data: reservation,
    isLoading,
    isError,
  } = homesPostBookingApi.useFetchHomesReservationQuery({
    reservationBookingId: reservationId,
  });

  useEffect(() => {
    if (isError) {
      dispatch(setSupportProductInfo());
      return navigateToTrips();
    }

    dispatch(
      setSupportProductInfo({
        productId: reservationId,
        productType: TravelCategory.Lodging,
      })
    );

    return () => {
      dispatch(setSupportProductInfo());
    };
  }, [isError, dispatch, navigateToTrips, reservationId]);

  return useMemo(
    () => ({
      reservation,
      isLoading: isLoading || reservation == null,
      isError,
    }),
    [reservation, isLoading, isError]
  );
};
